module.exports = __webpack_public_path__ + "img/14.55feef4d.jpg";